import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../../../Components/Loader/Loader";
import { allSets } from "../../../../Features/SetsAPI/SetsSlice";
import UBTPackages from "./UBTPackages";
import NormalSetsItem from "../../Components/NormalSetsItem";
import SetsItem from "../../Components/SetsItem";
const UBT = () => {
  const dispatch = useDispatch();
  let token = useSelector((state) => state.auth.currentUser.token);
  let allSetslist = useSelector((state) => state.set.allSets);
  let testState = useSelector((state) => state.localset.questionState);
  let isLoading = useSelector((state) => state.set.isLoading);
  useEffect(() => {
    if (!testState.start) {
      dispatch(allSets(token));
    }
  }, [dispatch]);
  const isBought = (status) => [true, 1, "true"].includes(status);
  return (
    <>
      {!isLoading ? (
        <>
          {allSetslist && (
            <>
             
              <div className="ubt-container">
                <Row>
                  <Col lg={9}>
                    <div>
                      <h2 className="dashboard-page-title">
                        UBT Test Sets 
                      </h2>
                      <div className="ubtSetQuestions setstitem-container">
                        {(() => {
                          const unboughtSets = allSetslist.filter(
                            (item) => !isBought(item.status)
                          );
                          const setsToShow =
                            unboughtSets.length > 0
                              ? unboughtSets
                              : [...allSetslist];
                          return setsToShow
                            .sort((a, b) => a.price - b.price)
                            .sort((a, b) => b.canAccessSet - a.canAccessSet)
                            .map((item, id) => (
                              <SetsItem key={id} details={item} />
                            ));
                        })()}
                      </div>
                    </div>
                  </Col>
                  <Col lg={3}>
                    <div className="sticky">
                     
                      <div className="package-bottom">
                        <div className="d-flex justify-content-between align-items-center">
                          <h2 className="dashboard-page-title">Packages</h2>
                        </div>
                        <UBTPackages />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </>
          )}
        </>
      ) : (
        <div className="loading__mode bigloading">
          <Loader />
        </div>
      )}
    </>
  );
};


export default UBT;

